import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import './scss/custom.scss';
import VueMq from 'vue-mq';
import App from './App.vue';
import VueRouter from 'vue-router';
import {routes} from './router';
import {store} from './store/store';
import i18n from './i18n';
import VueResource from 'vue-resource';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { faStop } from '@fortawesome/free-solid-svg-icons';
import { faPause } from '@fortawesome/free-solid-svg-icons';
import { faRedo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import './registerServiceWorker'



library.add(faPlay);
library.add(faStop);
library.add(faPause);
library.add(faRedo);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(VueResource);

Vue.config.productionTip = false

Vue.use(VueMq, {
  breakpoints: {
    mobile: 450,
    tablet: 900,
    laptop: 1400,
    desktop: Infinity,
  }
});

export const bus = new Vue();

const router = new VueRouter({
  mode: 'history',
  //mode: 'abstract',
  routes
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

//router.replace('/');
